import { Injectable } from "@angular/core";
import { LorenBaseEndpointsService } from "../../../../shared/services/loren-base-endpoints-service/loren-base-endpoints.service";

@Injectable({
  providedIn: "root",
})
export class LorenAutomationPlansEndpointsService extends LorenBaseEndpointsService {
  constructor() {
    super();
  }

  public userAutomationPlans() {
    return `${this.getApiServerUrl()}/automation-plans`;
  }

  public updatePlan(planId: number) {
    return `${this.getApiServerUrl()}/automation-plans/${planId}`;
  }
}
